import Typography from "typography";
import verticalRhythm from "compass-vertical-rhythm";

const blockvTheme = {
	title: "BLOCKv",
	baseFontSize: "16px",
	baseLineHeight: 1.61,
	headerFontFamily: ["Lato", "sans-serif"],
	bodyFontFamily: ["Lato", "sans-serif"],
	bodyWeight: 300,
	headerWeight: 400,
	boldWeight: 700,
	headerColor: "#1B1B30",
	bodyColor: "#636363",
	googleFonts: [
		{
			name: "Fira Mono",
			styles: ["400"],
		},
		{
			name: "Rajdhani",
			styles: ["300", "400", "500"],
		},
		{
			name: "Lato",
			styles: ["300", "300i", "400", "400i", "700", "700i"],
		},
	],

	scaleRatio: 1.61,
};

blockvTheme.overrideStyles = ({ adjustFontSizeTo, rhythm }, options, scale, styles) => ({
	a: {
		color: "#0000EE",
		textDecoration: "none",
	},
	"a:hover,a:active": {
		color: "#8784f9",
		textShadow: "none",
	},
	h1: {
		fontFamily: ["Rajdhani", "sans-serif"].join(","),
		fontWeight: 400,
		color: "#F0F2F7",
		textTransform: "uppercase",
		marginBottom: 0,
	},
	"h2, h3, h4, h5, h6, p, li": {
		marginLeft: rhythm(1),
		marginRight: rhythm(1),
	},
	h4: {
		fontWeight: 700,
	},
	code: {
		fontFamily: ["Fira Mono", "monospace"].join(","),
		fontWeight: 400,
	},
	"h3 > code": {
		...adjustFontSizeTo(rhythm(0.8)),
	},
	"h4 > code": {
		...adjustFontSizeTo(rhythm(0.6)),
	},
});

const typography = new Typography(blockvTheme);
export default typography;



// WEBPACK FOOTER //
// ./src/utils/typography.js